import React, { Component } from 'react';
import Raven from 'raven-js';
import styles from './error.scss';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Raven.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <div className={styles.container}>
          <img className={styles.gif} src="https://media.giphy.com/media/YyKPbc5OOTSQE/giphy.gif" alt=""/>
          <h2 className={styles.message}>Something went wrong.</h2>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/containers/app/error.jsx